import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "preview", "filename"]
  static values = {
    maxSize: { type: Number, default: 10485760 },
    acceptedTypes: { type: String, default: "image/jpeg,image/png,image/heic,application/pdf" }
  }

  connect() {
    this.dropzoneTarget.addEventListener("dragover", this.dragOver.bind(this))
    this.dropzoneTarget.addEventListener("dragleave", this.dragLeave.bind(this))
    this.dropzoneTarget.addEventListener("drop", this.drop.bind(this))
  }

  openFilePicker() {
    this.inputTarget.click()
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (file) this.validateAndPreview(file)
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-primary-500", "bg-primary-50")
    this.dropzoneTarget.classList.remove("border-neutral-300")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-primary-500", "bg-primary-50")
    this.dropzoneTarget.classList.add("border-neutral-300")
  }

  drop(event) {
    event.preventDefault()
    this.dragLeave(event)

    const file = event.dataTransfer.files[0]
    if (file) {
      this.inputTarget.files = event.dataTransfer.files
      this.validateAndPreview(file)
    }
  }

  validateAndPreview(file) {
    const accepted = this.acceptedTypesValue.split(",")
    if (!accepted.includes(file.type)) {
      this.showError("File type not allowed. Please upload a JPEG, PNG, HEIC, or PDF.")
      this.inputTarget.value = ""
      return
    }

    if (file.size > this.maxSizeValue) {
      this.showError("File is too large. Maximum size is 10MB.")
      this.inputTarget.value = ""
      return
    }

    this.clearError()
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = file.name
    }
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("hidden")
    }
  }

  showError(message) {
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }
    this.dispatch("error", { detail: { message } })
  }

  clearError() {
    this.dispatch("clearError")
  }
}
